import { DiscountType } from 'modules/data/backend';

export const toDiscountStateValue = (discountValue: number | null, discountType: DiscountType) => {
    switch (discountType) {
        case DiscountType.Rate:
        case DiscountType.PreRate:
            return discountValue ? `${discountValue}%` : '';

        case DiscountType.Amount:
        case DiscountType.PreAmount:
            return discountValue ? String(discountValue) : '';
    }
};
